












































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public data: any = [];
  public routeShow = false;
  public is996yinqing = false;
  public remark = "ICP证：浙B2-20240413 | ICP备案：浙ICP备2022020573号"; // 996m2 :浙ICP备2022020573号 ; 996yinqing :浙ICP备19016587号
  public copyright = "版权所有2022-2026";
  public address = "浙江省杭州市萧山区宁围街道保亿中心2幢4201室";
  public webSearchCode = "浙公网安备33010902004280号";
  public mounted() {
    const originUrl = location.host;
    if (originUrl.includes("996yinqing")) {
      this.remark = "ICP证：浙B2-20190699 | ICP备案：浙ICP备19016587号 | 广播电视节目制作经营许可证：（浙）字第07981号";
      this.copyright = "版权所有2019-2026";
      this.address = "浙江省杭州市萧山区宁围街道保亿中心2幢4203室";
      this.webSearchCode = "浙公网安备33010902003380号";
      this.is996yinqing = true;
    }
  }
  public parentList(data) {
    this.data = data;
  }
  public toOpen(paths) {
    const routeUrl = this.$router.resolve({
      path: paths,
    });
    window.open(routeUrl.href, "_blank");
  }
}
